import React from 'react';
import { bool, func, shape } from "prop-types"
import { faArrowRightFromBracket, faEdit, faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Divider, Modal } from 'antd';
import { isEmpty, map } from 'lodash';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import './style.scss';

const { confirm } = Modal;
function UserSettings({ data, handleExitMentorship, handleEditProfile, exitMentorshipLoading }) {
  const { form_1_data, form_2_data, form_3_data: mentor, form_4_data: mentee } = data;

  const handleExitMentorshipClick = () => {
    confirm({
      title: 'Leave mentorship program ',
      content: 'Are you sure you want to leave the program?',
      className: 'exit-mentorship-confirm',
      icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
      cancelButtonProps: { className: 'cancel-btn' },
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleExitMentorship();
      },
    });
  };

  return (
    <div className="mentorship-settings-wrapper">
      <div className="user-profile-details">
        <Avatar
          src={form_2_data?.profile?.present_picture}
          size={48}
          shape="square"
          icon={<FontAwesomeIcon icon={faUser} />} />
        <h6 className="arc-H200 mt16">{form_2_data?.profile?.full_name}</h6>
        <If condition={form_2_data?.profile?.introduction}>
          <p>{form_2_data?.profile?.introduction}</p>
        </If>
        <If condition={!isEmpty(mentor?.services) && form_1_data.is_mentor}>
          <div className="mt24">
            <h6 className="arc-H200">
              <I18nCustomFormatter id="offering-help-on" />
            </h6>
            {map(mentor?.services, (service) => (
              <p key={service.id}>{service.name}</p>
            ))}
          </div>
        </If>
        <If condition={!isEmpty(mentee?.services) && form_1_data.is_mentee}>
          <div className="mt24">
            <h6 className="arc-H200">
              <I18nCustomFormatter id="seeking-help-on" />
            </h6>
            {map(mentee?.services, (service) => (
              <p key={service.id}>{service.name}</p>
            ))}
          </div>
        </If>
        <Button
          className="edit-profile-btn mt24 arc-color-primary-imp"
          onClick={handleEditProfile}
          icon={<FontAwesomeIcon icon={faEdit} className="mr8 arc-color-primary" />}>
          <I18nCustomFormatter id="edit-profile-cta" />
        </Button>
      </div>
      <Divider />
      <div className="exit-mentorship-details">
        <h6 className="arc-H200">
          <I18nCustomFormatter id="leave-program-text" values={{ name: window.programDetails.name }} />
        </h6>
        <p className="arc-p arc-color-gray8">
          <I18nCustomFormatter id="leave-program-warning" />
        </p>
        <Button
          loading={exitMentorshipLoading}
          onClick={handleExitMentorshipClick}
          className="leave-mentorship-btn mt16 arc-color-primary-imp"
          icon={<FontAwesomeIcon icon={faArrowRightFromBracket} className="mr12" />}>
          <I18nCustomFormatter id="leave-program-text" values={{ name: window.programDetails.name }} />
        </Button>
      </div>
    </div>
  );
}

UserSettings.propTypes = {
  data: shape().isRequired,
  exitMentorshipLoading: bool.isRequired,
  handleEditProfile: func.isRequired,
  handleExitMentorship: func.isRequired
}

export default UserSettings;
